module.exports = __webpack_public_path__ + "images/img-3m9qoYz.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/63.jpg
// module id = 2013
// module chunks = 0